import React, { ComponentProps, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { ResearchId } from "../../../adapters/deep-research/state/AppState.ts";
import {
  useResearchHistory,
  useTermsAndConditionsState,
} from "../../../adapters/deep-research/state/hooks/stateHooks.ts";
import { useFeatureFlagValue } from "../../../config/FeatureFlagManager/hooks.ts";
import { HistorySidebar as HistorySidebarLegacy } from "../../../feature-components/HistorySidebar/HistorySidebar.tsx";
import { HistorySidebarRedesign } from "../../../feature-components/HistorySidebar/HistorySidebarRedesign.tsx";
import { CustomContextMenu } from "./CustomContextMenu.tsx";
import { NewChatIcon } from "../../../ui-library/_icons/NewChatIcon.tsx";

export const ConnectedHistorySidebar: React.FC = () => {
  const researchesState = useResearchHistory();

  const historyItems: ComponentProps<typeof HistorySidebarLegacy>["items"] =
    useMemo(
      () =>
        Object.values(researchesState.items)
          .filter((research) => {
            return (
              research.status === "completed" ||
              research.status === "processing_meta_analysis"
            );
          })
          .sort((a, b) => {
            return Date.parse(b.update_time) - Date.parse(a.update_time);
          })
          .map((research) => ({
            value: research.id as ResearchId,
            label: research.display_name || research.brief || "Untitled chat",
          })),
      [researchesState.items],
    );

  const termsState = useTermsAndConditionsState();
  const navigate = useNavigate();
  const { id } = useParams();
  const enableRedesign = useFeatureFlagValue("enableHistorySidebarRedesign");
  const HistorySidebar = enableRedesign
    ? HistorySidebarRedesign
    : HistorySidebarLegacy;

  return (
    <HistorySidebar
      items={historyItems}
      onNewChat={() => {
        navigate("/deep-research/new");
      }}
      onSelectionChange={(id) => {
        navigate(`/deep-research/${id}`);
      }}
      activeItem={id as ResearchId}
      enableTermsAndConditions={termsState.status !== "acceptance_not_required"}
      newChatLabel={
        <>
          <NewChatIcon
            style={{
              marginRight: 8,
              marginTop: -4,
              marginLeft: 5,
              width: 16,
              height: 16,
              verticalAlign: "middle",
              lineHeight: 0,
            }}
          />{" "}
          New Chat
        </>
      }
      ContextMenuComponent={CustomContextMenu}
    />
  );
};
